import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["parallax", "content", "scrollIndicator"]

  connect() {
    this.heroElement = this.element.querySelector(".gallery-hero-section, .noticia-hero-wrapper")
    this.likeFloatingElement = this.element.querySelector(".noticia-like-floating")

    if (this.likeFloatingElement) {
      this.likeFloatingElement.classList.add("is-hidden-by-hero")
      this.likeFloatingElement.classList.remove("is-visible")
    }

    this.onScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  handleScroll() {
    const scrollY = window.scrollY

    if (this.hasParallaxTarget) {
      const offset = scrollY * 0.45
      const opacity = Math.max(0, 1 - scrollY / 380)
      this.parallaxTarget.style.transform = `translateY(${offset}px)`
      this.parallaxTarget.style.opacity = opacity
    }

    if (this.hasScrollIndicatorTarget) {
      this.scrollIndicatorTarget.style.opacity = Math.max(0, 1 - scrollY / 80)
    }

    this.updateLikeVisibility()
  }

  updateLikeVisibility() {
    if (!this.heroElement || !this.likeFloatingElement) return

    const showAfterScroll = window.scrollY > 48

    this.likeFloatingElement.classList.toggle("is-hidden-by-hero", !showAfterScroll)
    this.likeFloatingElement.classList.toggle("is-visible", showAfterScroll)
  }

  async copyLink(event) {
    const trigger = event.currentTarget
    const url = `${window.location.origin}${window.location.pathname}`

    try {
      await navigator.clipboard.writeText(url)
    } catch {
      const input = document.createElement("input")
      input.value = url
      document.body.appendChild(input)
      input.select()
      document.execCommand("copy")
      document.body.removeChild(input)
    }

    trigger.classList.add("is-copied")
    clearTimeout(this.copyTimeout)
    this.copyTimeout = setTimeout(() => {
      trigger.classList.remove("is-copied")
    }, 1200)
  }
}
